import React from 'react';
import PropTypes from 'prop-types';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import { Link, Text } from 'components/ui';
import SentimentModal from 'components/ProductPage/RatingsAndReviews/HighlyRatedFor/SentimentModal/';
import UI from 'utils/UI';
import localeUtils from 'utils/LanguageLocale';

const MAX_PROS = 5;
const LIMIT_OF_REVIEWS = 6;
const SEPH_SENTIMENT_SOURCE = 'seph_sentiment';
const RATINGS_REVIEWS_ANCHOR = 'ratings-reviews-container';

// Analytics
import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';

import highlightedModalLoad from 'analytics/bindings/pages/all/highlightedModalLoad';

class HighlyRatedFor extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            selectedId: null,
            isModalOpen: false
        };
    }

    filter = index => {
        this.setState({ selectedId: index });
    };

    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    /* Returns only the MAX_PROS from amount of sentiments the list of sentiments, filtering out all the cons */
    filterProSentiments = sentiments => {
        const pros = sentiments.filter(sentiment => sentiment.type === 'pros');
        const prosList = pros.slice(0, MAX_PROS);

        return prosList;
    };

    fireAnalytics = () => {
        this.props.highlyRatedForClick();
        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data: {
                bindingMethods: [highlightedModalLoad]
            }
        });
    };

    handleSentimentClick = (item, index) => {
        this.fireAnalytics();

        if (this.props.isGenAIPRSEnabled) {
            this.props.loadHighlightedReviews({
                sentiment: item.sentiment,
                type: item.type,
                productId: this.props.product?.productDetails?.productId,
                limit: LIMIT_OF_REVIEWS,
                page: 0,
                language: localeUtils.getCurrentLanguage(),
                sentimentSource: SEPH_SENTIMENT_SOURCE
            });
            UI.scrollTo({ elementId: RATINGS_REVIEWS_ANCHOR });
        } else {
            this.filter(index);
            this.setState({ isModalOpen: true });
        }
    };

    /* Creates a list of links for the pros */
    createList = items => {
        const length = items.length;
        const { showPDPTopOfPageRedesign } = this.props;

        return items.map((item, index) => {
            const isLast = index + 1 === length || index + 1 === MAX_PROS;

            return (
                <React.Fragment key={item.sentiment}>
                    <Link
                        color='blue'
                        underline={!showPDPTopOfPageRedesign}
                        padding={1}
                        margin={-1}
                        key={item.sentiment}
                        onClick={() => this.handleSentimentClick(item, index)}
                        children={item.sentiment}
                    />
                    {isLast ? ' ' : ',  '}
                </React.Fragment>
            );
        });
    };

    render() {
        const { sentiments = [] } = this.props.product;
        const proSentiments = this.filterProSentiments(sentiments);
        const prosLinkList = this.createList(proSentiments);
        const { localization, onSentimentApply, showPDPTopOfPageRedesign } = this.props;
        const productId = this.props.product?.productDetails?.productId;
        const lead = showPDPTopOfPageRedesign ? localization.linkLeadRedesign : localization.linkLead;

        return (
            <>
                <SentimentModal
                    closeModal={this.closeModal}
                    proSentiments={proSentiments}
                    isModalOpen={this.state.isModalOpen}
                    productId={productId}
                    onSentimentApply={onSentimentApply}
                />
                <Text
                    is='p'
                    fontSize={showPDPTopOfPageRedesign ? ['sm-bg', 'base-bg'] : 'sm-bg'}
                >
                    {lead} {prosLinkList}
                </Text>
            </>
        );
    }
}

HighlyRatedFor.propTypes = {
    product: PropTypes.object.isRequired,
    localization: PropTypes.object.isRequired
};

export default wrapComponent(HighlyRatedFor, 'HighlyRatedFor');
